import { FC, ReactNode } from "react";
import styled from "@emotion/styled";
import {
  MDSDialogSlotName,
  MDSIcon,
  MDSIconKind,
  MDSModalDialog,
  MDSText,
  MDSTextVariant,
} from "@/mds";

interface BlockLightboxProps {
  isOpen: boolean;
  title: string;
  iconKind: MDSIconKind;
  onClose: () => void;
  children: ReactNode;
}

export const BlockLightbox: FC<BlockLightboxProps> = ({
  isOpen,
  title,
  iconKind,
  onClose,
  children,
}) => {
  return (
    <StyledDialog isOpen={isOpen} handleClose={onClose}>
      <Header slot={MDSDialogSlotName.Header}>
        <MDSIcon kind={iconKind} />
        <MDSText variant={MDSTextVariant.HeaderM}>{title || "Untitled block"}</MDSText>
      </Header>
      <Body slot={MDSDialogSlotName.Content}>{children}</Body>
    </StyledDialog>
  );
};

const StyledDialog = styled(MDSModalDialog)`
  .mds-dialog {
    padding: ${({ theme }) => theme.spacing[7]};
    width: min(960px, 92vw);
    max-height: 88vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding-bottom: ${({ theme }) => theme.spacing["2"]};
`;

const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-top: ${({ theme }) => theme.spacing["2"]};
`;
